import React, { useState } from 'react'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { Button, Popover } from '@material-ui/core'
import { MoreVertIcon } from '@resiliatech/birdsong'
import { DeleteOutline as DeleteIcon } from '@mui/icons-material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import TaskMenuItem from './TaskMenuItem'
import { TaskListMenuIcon } from './TaskMenu.styles'
import { TaskLinkManager } from './TaskLinkManager'

type TaskMenuProps = {
  isTaskMenuOpen: boolean
  menuAnchor: HTMLElement | null
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  onClose: () => void
  onDeleteTask: () => void
  onDuplicateTask: () => void
  onEditTask: () => void
  onSaveTaskLink: (linkText: string, linkUrl: string) => void
  taskId?: number
}

const TaskMenu: React.FC<TaskMenuProps> = ({
  isTaskMenuOpen,
  menuAnchor,
  onClick,
  onClose,
  onDeleteTask,
  onDuplicateTask,
  onEditTask,
  onSaveTaskLink,
  taskId,
}) => {
  const [isLinkManagerOpen, setIsLinkManagerOpen] = useState(false)

  if (!taskId) return null

  return (
    <>
      <TaskLinkManager
        isOpen={isLinkManagerOpen}
        onClose={() => setIsLinkManagerOpen(false)}
        onSaveTaskLink={onSaveTaskLink}
      />
      <Button onClick={onClick} id={`taskListMenu${taskId}`}>
        <TaskListMenuIcon>
          <MoreVertIcon />
        </TaskListMenuIcon>
      </Button>

      <Popover
        anchorEl={menuAnchor}
        open={isTaskMenuOpen}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <TaskMenuItem
          onClick={onEditTask}
          icon={<EditOutlinedIcon />}
          text='Edit'
        />
        <TaskMenuItem
          onClick={onDuplicateTask}
          icon={<ContentCopyIcon />}
          text='Duplicate'
        />
        <TaskMenuItem
          onClick={onDeleteTask}
          icon={<DeleteIcon />}
          text='Delete'
        />
      </Popover>
    </>
  )
}

export default TaskMenu
